var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  PatchedDataSchemaMark: () => PatchedDataSchemaMark,
  default: () => getPatchedDataSchema,
  isPatchedDataSchema: () => isPatchedDataSchema
});
module.exports = __toCommonJS(stdin_exports);
var import_tslib = require("tslib");
var import_omitBy = __toESM(require("lodash/omitBy"));
var import_DefinitionManager = __toESM(require("./DefinitionManager"));
var import_defineLazyGetter = __toESM(require("./utils/defineLazyGetter"));
var import_isNonNullable = require("./utils/isNonNullable");
var import_mergeArray = __toESM(require("./utils/mergeArray"));
var import_mergeDataSchema = __toESM(require("./utils/mergeDataSchema"));
const PatchedDataSchemaMark = Symbol("isPatchedDataSchema");
function isPatchedDataSchema(x) {
  return typeof x === "object" && x !== null && x[PatchedDataSchemaMark];
}
function getPatchedDataSchema(dataSchema) {
  const definitionManager = new import_DefinitionManager.default(dataSchema);
  const schemaToPatchedDataSchema = /* @__PURE__ */ new WeakMap();
  const patchDataSchema = (schema, { isObjectField = false } = {}) => {
    var _a, _b, _c, _d;
    {
      const prevAns = schemaToPatchedDataSchema.get(schema);
      if (prevAns)
        return prevAns;
      if (isPatchedDataSchema(schema)) {
        schemaToPatchedDataSchema.set(schema, schema);
        return schema;
      }
    }
    let ans = Object.assign({}, schema);
    schemaToPatchedDataSchema.set(schema, ans);
    (_a = ans.type) !== null && _a !== void 0 ? _a : ans.type = "any";
    if (isObjectField)
      (_b = ans.required) !== null && _b !== void 0 ? _b : ans.required = true;
    if (ans.type === "object")
      (_c = ans.fields) !== null && _c !== void 0 ? _c : ans.fields = [];
    if (ans.type === "array")
      (_d = ans.items) !== null && _d !== void 0 ? _d : ans.items = { type: "any" };
    if (ans.$ref) {
      const oldRef = ans.$ref;
      const refParent = definitionManager.getDefinition(oldRef);
      if (refParent) {
        const { id } = refParent, refParentWithoutId = (0, import_tslib.__rest)(refParent, ["id"]);
        ans = (0, import_mergeDataSchema.default)(ans, refParentWithoutId);
        ans.$refBeforePatched = oldRef;
        const currentSchemaHasChanges = (schema.type || refParent.type) !== refParent.type || Array.isArray(schema.fields) && schema.fields.length > 0 || !!schema.items || !!schema.additionalFields || false;
        if (!currentSchemaHasChanges) {
          ans.$isIdenticalToRef = schemaToPatchedDataSchema.get(refParent);
        }
      }
      delete ans.$ref;
    }
    ["fields"].forEach((k) => {
      const rawValue = ans[k];
      if (!Array.isArray(rawValue) || rawValue.length === 0)
        return;
      (0, import_defineLazyGetter.default)(ans, k, () => (0, import_mergeArray.default)(rawValue.filter(Boolean).map((x) => patchDataSchema(x, {
        isObjectField: true
      })), null, "id"));
    });
    ["items", "additionalFields"].forEach((k) => {
      const rawValue = ans[k];
      if (!rawValue)
        return;
      (0, import_defineLazyGetter.default)(ans, k, () => patchDataSchema(rawValue));
    });
    {
      const rawMethods = ans.methods;
      if (rawMethods) {
        (0, import_defineLazyGetter.default)(ans, "methods", () => (0, import_mergeArray.default)(rawMethods, null, "id").map((method) => (0, import_omitBy.default)(
          Object.assign(Object.assign({}, method), { arguments: (method.arguments || []).map((it) => patchDataSchema(it)), returnValue: method.returnValue && patchDataSchema(method.returnValue) }),
          import_isNonNullable.isNullish
        )));
      }
    }
    ans[PatchedDataSchemaMark] = true;
    return ans;
  };
  return patchDataSchema(dataSchema);
}
